import { Action, createReducer, on } from "@ngrx/store";

import { VendorActions } from "../actions/vendor.actions";
import { CountState } from "../models/count-state";

const initialState: CountState = {
	count: 0,
	loading: true
};

const reducer = createReducer(
	initialState,
	on(VendorActions.getCountSuccess, (state, action) => ({
		...state,
		...action.vendorCountState
	})),
	on(VendorActions.getCountFailed, (state, action) => ({
		...state,
		error: action.error,
		loading: false
	}))
);

export function vendorCountReducer(state: CountState | undefined, action: Action): CountState {
	return reducer(state, action);
}
